module.exports = __webpack_public_path__ + "img/as_con5_img.05958881.png";